import {CSSProperties, FC} from 'react';


export interface IIconEspNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEspNissan: FC<IIconEspNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m18.605 8.09-1.168-2.993C17.194 4.44 16.543 4 15.817 4H9.59c-.727 0-1.379.442-1.622 1.1L6.833 8.096a2.24 2.24 0 0 0-.746.485c-.415.407-.643.94-.643 1.501v3.691c0 .776.665 1.407 1.482 1.407.754 0 1.378-.538 1.47-1.23h8.653c.091.692.715 1.23 1.47 1.23.775 0 1.481-.587 1.481-1.23v-3.903c0-.886-.578-1.645-1.395-1.957ZM17 10.223v1.406h1.518v.21c0 .388-.332.704-.74.704H7.667c-.409 0-.741-.316-.741-.703v-.211H8.48v-1.406H6.926v-.141c0-.4.34-.738.74-.738h10.112c.408 0 .74.315.74.703v.176H17ZM9.366 5.567a.246.246 0 0 1 .225-.16h6.225c.098 0 .19.065.225.16l.925 2.37H8.467l.897-2.363.002-.007Zm-1.21 10.984c.191.286.288.585.288.896 0 .982-.953 1.623-1.794 2.189-.354.238-.689.463-.922.685a.45.45 0 0 0-.014.653c.163.164.426.377.835.582.4.2.808.353 1.074.444H4.657C4.22 21.589 4 21.146 4 20.677c0-.982.953-1.623 1.794-2.189.354-.238.69-.463.922-.685l.007-.007a.45.45 0 0 0 .007-.646 3.18 3.18 0 0 0-.852-.593l-.014-.006h2.291Zm11.555 0c.192.286.289.585.289.896 0 .982-.953 1.623-1.794 2.189-.354.238-.69.463-.922.685a.45.45 0 0 0-.014.653c.163.164.426.377.835.582.4.2.808.353 1.073.444h-2.965c-.437-.411-.657-.854-.657-1.323 0-.982.953-1.623 1.793-2.189.355-.238.69-.463.923-.685l.007-.007a.45.45 0 0 0 .006-.646 3.18 3.18 0 0 0-.852-.593l-.013-.006h2.29Z" />
        </svg>
    );
};
